import React, { ReactElement } from 'react'
import styled from 'styled-components'

interface FieldsProps {
    name?: string
    changeConfig?: (name: GenericValueType, opts?: boolean, updateQuery?: boolean) => null
    children?: ReactElement
    widgetConfig?: Configs
    isEditor: boolean
    defaultValue: any
}

export type Configs = {
    colorScaleOption: string
    hideXAxis: boolean
    kind: string
    numberOfVisibleAxes: number
    properties: { query: { reducer: string }; reducerType: string }
    scaleMax: number
    scaleMin: number
    span: string
    spanFinal: string
    spanPicker: {
        type: string
        configs: {
            depth?: { advancedMode: boolean; selectedOption: string }
            time?: { advancedMode: boolean; selectedOption: string }
        }
    }
    useDefaultMinMax: boolean
    verticalEnabled: boolean
    configField?: string
}

Fields.defaultProps = {
    isEditor: false
}

export default function Fields(props: FieldsProps): ReactElement {
    return (
        <FieldsetWrapper>
            {React.Children.map(props.children, function (children) {
                const Field = children?.type
                const configField: string = children?.props.configField
                const updateQuery: boolean = children?.props.updateQuery ?? true
                if (children?.props.editorOnly && !props.isEditor) {
                    return null
                }
                if (typeof children?.props.skipOn === 'function' && children?.props.skipOn(props.widgetConfig)) {
                    return null
                }

                function updateValue(value: boolean | number | string | ((t: number) => string)): void {
                    if (props.changeConfig) {
                        props.changeConfig(configField, value, props.isEditor ? undefined : { updateQuery })
                    }
                }

                if (children?.type?.displayName?.startsWith('styled.')) {
                    return children
                }

                return (
                    <FieldWrapper>
                        <Field
                            className={props.isEditor ? '' : ' dropdown-toggler--cancel-drag'}
                            {...children.props}
                            value={(props.widgetConfig || {})[configField]}
                            defaultValue={children.props.defaultValue}
                            widgetConfig={props.widgetConfig}
                            onChange={updateValue}
                            dark={!props.isEditor}
                        />
                    </FieldWrapper>
                )
            })}
        </FieldsetWrapper>
    )
}

const FieldsetWrapper = styled.div`
    padding: 13px 0;
`

const FieldWrapper = styled.div`
    margin: 0 10px 25px;
`
